import DCompanyDirectoryPage from './DCompanyDirectoryPage'

export default DCompanyDirectoryPage
